<template>
  <ResetPasswordBody/>
</template>

<script>
// @ is an alias to /src
import ResetPasswordBody from '@/components/ResetPasswordBody.vue'

export default {
  name: 'ResetPasswordView',
  components: {
    ResetPasswordBody
  }
}
</script>
